import { useSelector } from 'react-redux';
import { IFeedbackPopupProps } from '@bridebook/web/components/settings/feedback-popup/index';
import { IApplicationState } from '@bridebook/web/lib/types';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const FeedbackPopup = lazyComponent<IFeedbackPopupProps>(
  () => import('@bridebook/web/components/settings/feedback-popup'),
);

interface FeedbackPopupLazyProps {}

const FeedbackPopupLazy: React.FC<FeedbackPopupLazyProps> = () => {
  const show = useSelector<IApplicationState, boolean>((state) => state.settings.showFeedbackPopup);

  if (!show) return null;

  return <FeedbackPopup showFeedbackPopup={show} />;
};

export default memo(FeedbackPopupLazy);
